import React from 'react'

const Pulse = ({scale, translate}) => {
  return (
    (
      <>
        <animateTransform
          attributeName="transform"
          type="scale"
          additive="sum"
          values={scale}
          dur="0.75s"
          repeatCount="indefinite" />
        <animateTransform
          attributeName="transform"
          type="translate"
          additive="sum"
          values={translate}
          dur="0.75s"
          repeatCount="indefinite" />
      </>
    )
  )
}

export default Pulse
